import './bootstrap';
import './skeleton-regions';
import './sentry';
import { trySubscribeWebPush } from './webpush';
import * as Pwa from './pwa';
import { surveyResponseForm } from './survey-response-form';
import { surveyBuilder } from './survey-builder';
import { communityComposer } from './community-composer';
import { WebAuthn, createPasskeyClient } from './passkeys';

import Alpine from 'alpinejs';

window.trySubscribeWebPush = trySubscribeWebPush;
window.Pwa = Pwa;
Pwa.bootPwa();
window.surveyResponseForm = surveyResponseForm;
window.surveyBuilder = surveyBuilder;
window.communityComposer = communityComposer;
window.Passkeys = { WebAuthn, createPasskeyClient };

window.Alpine = Alpine;
Alpine.data('surveyBuilder', surveyBuilder);
Alpine.data('communityComposer', communityComposer);

// Handle Alpine.js transition errors
window.addEventListener('unhandledrejection', function(event) {
    // Suppress known Alpine.js transition errors
    if (event.reason && (
        (typeof event.reason === 'object' && event.reason.isFromCancelledTransition) ||
        (typeof event.reason === 'string' && event.reason.includes('Cannot read properties of undefined'))
    )) {
        event.preventDefault();
        console.warn('Suppressed Alpine.js error:', event.reason);
        return;
    }
    
    // Let other unhandled rejections through
    console.error('Unhandled promise rejection:', event.reason);
});

// Suppress specific Alpine.js errors
window.addEventListener('error', function(event) {
    if (event.message && event.message.includes('Cannot read properties of undefined')) {
        event.preventDefault();
        console.warn('Suppressed Alpine.js error:', event.message);
        return;
    }
});

// Global CSRF Token Mismatch (419) Error Handler
(function() {
    'use strict';
    
    // Handle 419 errors for AJAX requests
    if (window.axios) {
        // Add response interceptor for axios
        window.axios.interceptors.response.use(
            function (response) {
                return response;
            },
            function (error) {
                // Check if it's a 419 error (CSRF token mismatch)
                if (error.response && error.response.status === 419) {
                    const cooldownKey = 'axios_419_reload_at';
                    const cooldownMs = 120000;
                    const lastReload = parseInt(sessionStorage.getItem(cooldownKey) || '0', 10);
                    if (Date.now() - lastReload < cooldownMs) {
                        console.warn('CSRF token mismatch (419): skipping auto-reload to avoid a loop. Refresh manually or log in again.');
                        return Promise.reject(error);
                    }
                    sessionStorage.setItem(cooldownKey, String(Date.now()));
                    console.warn('CSRF token mismatch detected. Refreshing page once...');
                    
                    // Show a brief notification
                    const notification = document.createElement('div');
                    notification.className = 'fixed top-4 right-4 bg-orange-500 text-white px-6 py-3 rounded-lg shadow-lg z-50 flex items-center space-x-2';
                    notification.innerHTML = `
                        <svg class="w-5 h-5 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
                        </svg>
                        <span>Session expired. Refreshing page...</span>
                    `;
                    document.body.appendChild(notification);
                    
                    // Refresh the page after a short delay
                    setTimeout(() => {
                        window.location.reload();
                    }, 1500);
                    
                    return Promise.reject(error);
                }
                return Promise.reject(error);
            }
        );
    }
    
    // Handle 419 errors for regular form submissions
    document.addEventListener('submit', function(event) {
        const form = event.target;
        if (form.tagName === 'FORM') {
            // Intercept form submission
            const originalSubmit = form.onsubmit;
            form.addEventListener('submit', function(e) {
                // This will be handled by the response if it's a 419
            }, true);
        }
    });
    
    // Only treat our dedicated 419 view as a 419 page. Do not scan body text for "419" —
    // real data (phones, IDs, amounts) often contains those digits and caused reload loops.
    if (document.body && document.body.dataset.laravelHttpError === '419') {
        if (!sessionStorage.getItem('419_handled')) {
            sessionStorage.setItem('419_handled', 'true');
            const isLoginPage = window.location.pathname.includes('/login');
            const delay = isLoginPage ? 3000 : 5000;
            setTimeout(() => {
                sessionStorage.removeItem('419_handled');
                window.location.reload();
            }, delay);
        }
    } else if (document.body) {
        sessionStorage.removeItem('419_handled');
    }
    
    // Session keep-alive: Ping server every 10 minutes to keep session alive
    // Default to 120 minutes (2 hours) if not available
    const sessionLifetimeMinutes = window.Laravel?.sessionLifetime || 120;
    const sessionLifetime = sessionLifetimeMinutes * 60 * 1000; // Convert to milliseconds
    const keepAliveInterval = Math.min(sessionLifetime * 0.5, 10 * 60 * 1000); // Half of session lifetime or 10 minutes, whichever is less
    
    setInterval(function() {
        // Only ping if user is authenticated and page is visible
        if (document.querySelector('meta[name="csrf-token"]') && !document.hidden) {
            fetch(window.location.origin + '/api/ping', {
                method: 'GET',
                headers: {
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                    'X-Requested-With': 'XMLHttpRequest'
                }
            }).catch(function(error) {
                // Silently fail - don't interrupt user experience
                console.debug('Session keep-alive ping failed:', error);
            });
        }
    }, keepAliveInterval);
    
    // Update CSRF token in meta tag and forms when page loads
    document.addEventListener('DOMContentLoaded', function() {
        if (!document.body?.dataset?.laravelHttpError) {
            sessionStorage.removeItem('laravel_419_page_auto_refresh_count');
        }
        const csrfToken = document.querySelector('meta[name="csrf-token"]');
        if (csrfToken) {
            // Update all CSRF token inputs in forms
            document.querySelectorAll('input[name="_token"]').forEach(function(input) {
                input.value = csrfToken.getAttribute('content');
            });
        }
    });
})();

Alpine.start();